import { ColumnsType } from 'antd/es/table'
import { QUOTA_TYPE_ENUM_MAP } from './constants'

export const columns: ColumnsType<any> = [
  {
    title: '流水单号',
    dataIndex: 'serialNo',
    align: 'center',
  },
  {
    title: '额度变动类型',
    dataIndex: 'quotaType',
    align: 'center',
    render: t => QUOTA_TYPE_ENUM_MAP.get(t) || '-',
  },
  {
    title: '变动前可用额度',
    dataIndex: 'changeAmountBefore',
    align: 'center',
  },
  {
    title: '本次变动额度',
    dataIndex: 'changeAmount',
    align: 'center',
  },
  {
    title: '变动后可用额度',
    dataIndex: 'changeAmountAfter',
    align: 'center',
  },
  {
    title: '操作时间',
    dataIndex: 'createTime',
    align: 'center',
  },
  {
    title: '备注',
    dataIndex: 'remark',
    align: 'center',
  },
]
